// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3KnDv","content":"GlobalSearch_content__28lW1"};